<template>
  <div class="cc-date-filter">
    <div class="cc-date-filter__wrapper">
      <p class="cc-date-filter__content" :class="visiblecancel==false? 'width2':'width1'" @click="showDatePicker('visibleStartDate')">{{this.startDate || '开始时间'}}</p>
      <span>~</span>
      <p class="cc-date-filter__content" :class="visiblecancel==false? 'width2':'width1'" @click="showDatePicker('visibleEndDate')">{{this.endDate || '结束时间'}}</p>
      <p class="cc-date-filter__content" :class="visiblecancel==false? 'width2':'width1'" >
        <cc-svg-icon icon-class='cancel' v-if="visiblecancel"  class="mr15"  @click="$emit('cancel', {
        startDate,
        endDate
      })"></cc-svg-icon>
        <cc-svg-icon icon-class='search' @click="$emit('search', {
        startDate,
        endDate
      })" ></cc-svg-icon>
      </p>
    </div>

    <nut-datepicker
      :is-visible="visibleStartDate"
      title="请选择开始日期"
      type="date"
      :defaultValue='defaultDate'
      @close="switchPicker('visibleStartDate')"
      @choose="setChooseStartValue"
    >
    </nut-datepicker>
    <nut-datepicker
      v-if="startDate"
      :is-visible="visibleEndDate"
      title="请选择结束日期"
      type="date"
      :defaultValue='defaultDate'
      @close="switchPicker('visibleEndDate')"
      @choose="setChooseEndValue"
    >
    </nut-datepicker>
  </div>
</template>
<script>
/**
 * @description 日期过滤组件
 */
import Vue from 'vue'
import dayjs from 'dayjs'
import { DatePicker } from '@nutui/nutui'
import { Toast } from 'vant'
DatePicker.install(Vue)
Vue.use(Toast)
export default {
  name: 'cc-date-filter',
  data () {
    return {
      /**
       * 开始时间
       */
      startDate: '',
      /**
       * 结束时间
       */
      endDate: '',
      /**
       * 显示 开始时间 日期组件
       */
      visibleStartDate: false,
      /**
       * 显示 结束时间 日期组件
       */
      visibleEndDate: false,
      visiblecancel: false,
      /**
       * 默认选中今天
       */
      defaultDate: dayjs().format('YYYY-MM-DD')
    }
  },
  watch: {
    startDate () {
      if (this.startDate !== '') {
        this.visiblecancel = true
      } else {
        this.visiblecancel = false
      }
    }
  },
  created () {
  },
  methods: {
    showDatePicker (param) {
      if (this.startDate === '') {
        this.visibleStartDate = true
        return
      }
      this[param] = true
    },
    switchPicker (param) {
      this[`${param}`] = !this[`${param}`]
      this.diffDate()
    },
    setChooseStartValue (param) {
      this.startDate = param[3]
    },
    setChooseEndValue (param) {
      this.endDate = param[3]
      this.diffDate()
    },
    diffDate () {
      const startDateMs = dayjs(this.startDate.valueOf())
      const endDateMs = dayjs(this.endDate.valueOf())
      if (endDateMs < startDateMs) {
        Toast('结束时间不能小于开始时间')
        this.visibleEndDate = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~styles/var.scss';
@import '~styles/mixins.scss';
.cc-date-filter {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  background: #fff;
  height: 40px;
  padding: 5px 0;
  box-sizing: border-box;

  &__wrapper {
    height: 26px;
    position: relative;
    width: 92%;
    margin: 0 auto;
    @include center(row);
    border: 1px solid #E5E5E5;
  }
  .width1{
    width: 40%;
  }
  .width2{
    width: 45%;
  }
  &__content {
    height: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    &:last-child {
      flex: 1;
    }
  }
}
</style>
